import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import MuiTextField from '@material-ui/core/TextField';

const useTextFieldStyles = makeStyles((theme) => ({
    root: {
        '& .MuiFormControl-root.MuiTextField-root': {
            marginBottom: '30px !important',
        },
        '& .MuiFormLabel-root.Mui-focused': {
            color: '#8692A6',
        },
        '& .MuiFilledInput-root': {
            backgroundColor: '#F7F7F7',
            borderRadius: '6px',
        },
        '& .MuiInputBase-root': {
            border: '1px solid transparent',
            fontSize: 16,
        },
        '& .MuiInputBase-root #placeholder': {
            fontSize: '16px',
        },
        '& .MuiInputBase-root input[data-id=register-code]': {
            padding: '20px 12px 20px',
            textAlign: 'center',
            letterSpacing: '0.51em',
            [theme.breakpoints.down('xs')]: {
                padding: '18px 12px 17px;',
            },
        },
        '& .MuiInputBase-root.Mui-error': {
            border: '1px solid #F90000',
        },
        '& .MuiInputBase-root:not(.Mui-error):hover': {
            border: '1px solid #DCDCDC',
        },
        '& .MuiInputBase-root:not(.Mui-error).Mui-focused': {
            border: '1px solid #1094F7',
        },
        '& .MuiFormHelperText-root': {
            lineHeight: '16px',
        },
        '& .MuiFormHelperText-root.Mui-error': {
            color: '#F90000',
            fontSize: 14,
            lineHeight: '16px',
        },
        '& .MuiInputBase-input.MuiFilledInput-input': {
            borderRadius: '6px',
            padding: '29px 12px 10px',
            [theme.breakpoints.down('xs')]: {
                borderRadius: '6px',
                padding: '27px 12px 8px',
            },
        },
        '& .MuiFilledInput-underline:after': {
            border: 'none',
        },
        '& .MuiFilledInput-underline:before': {
            border: 'none',
        },
    },
}));

export const TextField = (props) => {
    const textFieldStyles = useTextFieldStyles();

    return (
        <MuiTextField
            InputProps={{
                disableUnderline: true,
                autocomplete: 'new-password',
                form: {
                    autocomplete: 'off',
                },
            }}
            classes={textFieldStyles}
            variant="filled"
            {...props}
        />
    );
};
